import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CompaniesComponent } from "./companies.component";
import { CompanyRoutingModule } from "./company-routing.module";
import { MaterialModule } from "../material-module";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { EmptyRecordModule } from "../share/component/empty-record/empty-record.module";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { NgxMaskModule } from "ngx-mask";
import { CustomDirectiveModule } from "../share/directive/custom-directive.module";
import { CustomPipeModule } from "../share/pipes/custom-pipe.module";
import { CreateUpdateCompanyDialogComponent } from "./ui/components/create-company-dialog/create-update-company-dialog.component";

@NgModule({
	declarations: [CompaniesComponent, CreateUpdateCompanyDialogComponent],
	imports: [
		CommonModule,
		CompanyRoutingModule,
		MaterialModule,
		TranslateModule,
		ReactiveFormsModule,
		FormsModule,
		FlexLayoutModule,
		MatBottomSheetModule,
		NgxMatSelectSearchModule,
		EmptyRecordModule,
		NgxSkeletonLoaderModule,
		NgxMaskModule,
		CustomDirectiveModule,
		CustomPipeModule,
	],
})
export class CompanyModule {}
